import { render } from "./workbench.vue?vue&type=template&id=18b77c98&scoped=true"
import script from "./workbench.vue?vue&type=script&lang=js"
export * from "./workbench.vue?vue&type=script&lang=js"

import "./workbench.vue?vue&type=style&index=0&id=18b77c98&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b77c98"],['__file',"src/views/index/workbench.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18b77c98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18b77c98', __exports__)) {
    console.log('reload')
    api.reload('18b77c98', __exports__)
  }
  
  module.hot.accept("./workbench.vue?vue&type=template&id=18b77c98&scoped=true", () => {
    console.log('re-render')
    api.rerender('18b77c98', render)
  })

}


export default __exports__